import { render, staticRenderFns } from "./RejectReasonModal.vue?vue&type=template&id=6f43162c&"
import script from "./RejectReasonModal.vue?vue&type=script&lang=ts&"
export * from "./RejectReasonModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports